import state from './moduleNumberBlacklistState'
import actions from './moduleNumberBlacklistActions'
import getters from './moduleNumberBlacklistGetters'
import mutations from './moduleNumberBlacklistMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
